import React, { useCallback, useEffect, useRef } from 'react';
import MoldDetails from './MoldDetails';
import { MoldPropType } from '../../helpers/prop-types';
import PropTypes from 'prop-types';
import styles from './Mold.module.scss';

// If user taps twice in 200 ms, it's considered as a double-tap
const DOUBLE_TAP_THRESHOLD = 200;

let lastClick = 0;

const Mold = ({ isSelected, mold, onClick, onDoubleClick }) => {
  const { brand, cavityCount, cavityVolume, dimensions, title, url } = mold;

  const moldRef = useRef(null);

  const handleOnClick = useCallback(() => onClick(mold), [onClick]);
  const handleOnDoubleClick = useCallback((event) => onDoubleClick(event, mold), [onDoubleClick]);

  const handleOnTouchStart = useCallback(
    (event) => {
      const now = Date.now();
      if (now - lastClick < DOUBLE_TAP_THRESHOLD) {
        event.preventDefault();
        onDoubleClick(event, mold);
      }
      lastClick = now;
    },
    [onDoubleClick]
  );

  // Initialization
  useEffect(() => {
    moldRef.current.addEventListener('click', handleOnClick);
    moldRef.current.addEventListener('dblclick', handleOnDoubleClick);
    moldRef.current.addEventListener('touchstart', handleOnTouchStart);

    return () => {
      moldRef.current?.removeEventListener('click', handleOnClick);
      moldRef.current?.removeEventListener('dblclick', handleOnDoubleClick);
      moldRef.current?.removeEventListener('touchstart', handleOnTouchStart);
    };
  }, [handleOnClick, handleOnDoubleClick, handleOnTouchStart]);

  return (
    <div className={`${styles.pickerMold} ${isSelected ? styles.selected : ''}`} ref={moldRef}>
      <div className={styles.pickerMoldTitle}>
        <div className={styles.brand}>{brand}</div>
        <div className={styles.title}>{title}</div>
      </div>
      <MoldDetails>
        <div className={styles.pickerMoldData}>
          <a className={styles.pickerMoldLink} href={url} rel='noopener noreferrer' target='_blank'>
            voir
          </a>
        </div>
        <div className={styles.pickerMoldData}>{cavityCount}</div>
        <div className={styles.pickerMoldData}>{cavityVolume}&nbsp;ml</div>
        <div className={styles.pickerMoldData}>{dimensions}</div>
      </MoldDetails>
    </div>
  );
};

Mold.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  mold: MoldPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
};

export default Mold;
